import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { dropUndefinedKeys } from '@sentry/utils';

/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */

var METRICS_SPAN_FIELD = '_sentryMetrics';

/**
 * Fetches the metric summary if it exists for the passed span
 */
function getMetricSummaryJsonForSpan(span) {
  var storage = span[METRICS_SPAN_FIELD];
  if (!storage) {
    return undefined;
  }
  var output = {};
  var _iterator = _createForOfIteratorHelper(storage),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        _step$value$ = _slicedToArray(_step$value[1], 2),
        exportKey = _step$value$[0],
        summary = _step$value$[1];
      var arr = output[exportKey] || (output[exportKey] = []);
      arr.push(dropUndefinedKeys(summary));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return output;
}

/**
 * Updates the metric summary on a span.
 */
function updateMetricSummaryOnSpan(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
  var existingStorage = span[METRICS_SPAN_FIELD];
  var storage = existingStorage || (span[METRICS_SPAN_FIELD] = new Map());
  var exportKey = "".concat(metricType, ":").concat(sanitizedName, "@").concat(unit);
  var bucketItem = storage.get(bucketKey);
  if (bucketItem) {
    var _bucketItem = _slicedToArray(bucketItem, 2),
      summary = _bucketItem[1];
    storage.set(bucketKey, [exportKey, {
      min: Math.min(summary.min, value),
      max: Math.max(summary.max, value),
      count: summary.count += 1,
      sum: summary.sum += value,
      tags: summary.tags
    }]);
  } else {
    storage.set(bucketKey, [exportKey, {
      min: value,
      max: value,
      count: 1,
      sum: value,
      tags: tags
    }]);
  }
}
export { getMetricSummaryJsonForSpan, updateMetricSummaryOnSpan };
//# sourceMappingURL=metric-summary.js.map